<template lang="pug">
  v-app-bar.headernavbar(app clipped-left)
    v-app-bar-nav-icon(@click.stop="$emit('menuEvent')")
      v-icon mdi-menu
    v-img.ml-0.ml-sm-4.fill-height.headernavbar__logo(src="@/assets/logo_emara3.png" alt="Emara play" position="left center" contain)
    v-spacer
    ButtonSelectLenaguage(:translations="$t('components.headerNabvar')")
    v-app-bar-nav-icon(@click.stop="$emit('logoutEvent')")
      v-icon mdi-power
</template>

<script>
  import ButtonSelectLenaguage from '@/components/buttons/ButtonSelectLenaguage';

  export default {
    name: "HeaderNabvar",
    components: {
      ButtonSelectLenaguage
    }
  }
</script>

<style lang="sass">
.headernavbar
  &__logo
    max-width: 150px
    min-width: 120px
    @media (min-width: 600px)
      max-width: 250px
  &__flag
    width: 24px
</style>

